import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import AddTemplate from "../layout/templates/AddTemplate";
import EditTemplate from "../layout/templates/EditTemplate";
import AddChildTemplate from "../layout/templates/AddChildTemplate";
import Templates from "../layout/templates/Templates";
const TemplatesPage = () => {
    useEffect(() => {
        return() =>{
            localStorage.removeItem("selectedId")
            localStorage.removeItem("itemOffset")
            localStorage.removeItem("forcePage")
        }
    }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Templates />} />
        <Route path="/add" element={<AddTemplate />} />
        <Route path="/update/:id" element={<EditTemplate />} />
        <Route path="/update/:parentId/add-child" element={<AddChildTemplate />} />
        <Route path="/update/:parentId/update-child/:id" element={<AddChildTemplate />} />
      </Routes>
    </>
  );
};

export default TemplatesPage;
